import "../scss/main.scss";

//Mobile Menu Toggle
document.addEventListener("DOMContentLoaded", () => {
	const burger = document.querySelector(".burger");
	const fullscreenMenu = document.querySelector("nav.fullscreen-menu");
	const closeBtn = document.querySelector(".fullscreen-menu-close");
	const focusableSelectors =
		'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

	let lastFocusedElement = null;

	// Trap focus inside fullscreen menu
	function trapFocus(element) {
		const focusableElements = element.querySelectorAll(focusableSelectors);
		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		function handleFocus(event) {
			if (event.key !== "Tab") return;

			if (event.shiftKey) {
				// Shift + Tab
				if (document.activeElement === firstFocusable) {
					event.preventDefault();
					lastFocusable.focus();
				}
			} else {
				// Tab
				if (document.activeElement === lastFocusable) {
					event.preventDefault();
					firstFocusable.focus();
				}
			}
		}

		element.addEventListener("keydown", handleFocus);
		return () => element.removeEventListener("keydown", handleFocus);
	}

	let releaseFocusTrap = null;

	function openMenu() {
		lastFocusedElement = document.activeElement;
		fullscreenMenu.classList.add("active");
		burger.classList.add("open"); // 👈 ADDED
		closeBtn.style.display = "block";
		burger.setAttribute("aria-expanded", "true");
		document.body.style.overflow = "hidden";

		const firstLink = fullscreenMenu.querySelector("a");
		if (firstLink) {
			firstLink.focus();
		} else {
			closeBtn.focus();
		}

		releaseFocusTrap = trapFocus(fullscreenMenu);
	}

	function closeMenu() {
		fullscreenMenu.classList.remove("active");
		burger.classList.remove("open"); // 👈 ADDED
		closeBtn.style.display = "none";
		burger.setAttribute("aria-expanded", "false");
		document.body.style.overflow = "";
		if (lastFocusedElement) lastFocusedElement.focus();

		if (releaseFocusTrap) {
			releaseFocusTrap();
			releaseFocusTrap = null;
		}
	}

	burger.addEventListener("click", () => {
		if (fullscreenMenu.classList.contains("active")) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	closeBtn.addEventListener("click", closeMenu);

	// Close menu on Escape key
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && fullscreenMenu.classList.contains("active")) {
			closeMenu();
		}
	});
});
